var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBannerLagging(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 48 48",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M39.061,9.439c-0.586-0.586-1.535-0.586-2.121,0L24,22.379L11.061,9.439c-0.586-0.586-1.535-0.586-2.121,0l-6.5,6.5 c-0.586,0.586-0.586,1.535,0,2.121l20.5,20.5C23.232,38.854,23.616,39,24,39s0.768-0.146,1.061-0.439l20.5-20.5 c0.586-0.586,0.586-1.535,0-2.121L39.061,9.439z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBannerLagging);
export default __webpack_public_path__ + "static/media/banner-lagging.e557d91890e87765a51148165ae0af5c.svg";
export { ForwardRef as ReactComponent };